import { tabCloser, tabTemplate, categoryTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeCohorts } from '../actions';
import CohortsActions from '../containers/CohortsActions';
import CohortsPanel from '../components/CohortsPanel';

export default {
  ...tabTemplate('cohorts', CohortsPanel, matchSingleUrl(['cohorts']), CohortsActions),
  ...tabCloser('closeCohortsTab', closeCohorts),
  access: ({ cohorts }) => cohorts.read,
  componentState: ({ url }) => categoryTab(url, 'saved'),
  icon: 'fas fa-list-alt',
  dropDownIcon: 'list alternate',
  order: 400,
  position: 'top-right',
};
